import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { cn } from '@/lib/cn'

export interface PageHeaderProps {
  title: ReactNode
  /** Wiersz pod tytułem, np. „47 spraw w toku · 12 oczekuje na termin". */
  subtitle?: ReactNode
  /** Przyciski po prawej stronie. */
  actions?: ReactNode
  /** Link powrotu nad tytułem, np. „← Sprawy". */
  back?: { to: string; label: string }
  /** Elementy między linkiem powrotu a tytułem (sygnatura, chipy statusu). */
  eyebrow?: ReactNode
  className?: string
}

/** Nagłówek strony w układzie z mockupów: tytuł Spectral + podpis + akcje. */
export function PageHeader({ title, subtitle, actions, back, eyebrow, className }: PageHeaderProps) {
  return (
    <header className={cn('mb-6', className)}>
      {back ? (
        <Link to={back.to} className="mb-2.5 inline-block text-small text-muted transition-colors hover:text-ink">
          ← {back.label}
        </Link>
      ) : null}
      {eyebrow ? <div className="mb-2 flex flex-wrap items-center gap-3">{eyebrow}</div> : null}
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0">
          <h1 className="t-h1">{title}</h1>
          {subtitle ? <p className="mt-2 text-base text-muted">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
    </header>
  )
}
